module.exports = __webpack_public_path__ + "static/media/liamtjoa.21f33051.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/liamtjoa.webp
// module id = 542
// module chunks = 0